/*
 * Fondo a cuadros de tono medio para imágenes con transparencia. Dos tonos del
 * sistema, uno claro y uno de borde fuerte, para que un logo en tinta blanca
 * se lea igual que uno en negro. Sin esto, una variante blanca sobre una
 * superficie clara sale como un recuadro vacío.
 */
export const CHECKER_BG = {
  backgroundColor: 'var(--color-bg-elevated)',
  backgroundImage:
    'linear-gradient(45deg, var(--color-border-strong) 25%, transparent 25%, transparent 75%, var(--color-border-strong) 75%), ' +
    'linear-gradient(45deg, var(--color-border-strong) 25%, transparent 25%, transparent 75%, var(--color-border-strong) 75%)',
  backgroundSize: '16px 16px',
  backgroundPosition: '0 0, 8px 8px',
} as const;
